import {useState,type FormEvent} from 'react';

type Category='BUG'|'QUESTION'|'SUGGESTION';
const categoryLabels:Record<Category,string>={
  BUG:'Report a Problem',QUESTION:'Ask a Question',SUGGESTION:'Make a Suggestion',
};
/** One shared prototype Help & Feedback destination for the Account menu
 * and Point of Sale/Omnibar help. Never sends SMS or emails. */
export function HelpFeedbackModal({locationCode,onClose}:{
  locationCode:string;onClose:()=>void;
}){
  const [category,setCategory]=useState<Category>('BUG');
  const [subject,setSubject]=useState('');
  const [description,setDescription]=useState('');
  const [requestKey,setRequestKey]=useState(()=>crypto.randomUUID());
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [saved,setSaved]=useState<{taskId:string}|null>(null);
  const edit=()=>{setRequestKey(crypto.randomUUID());setError('');};
  const submit=async(event:FormEvent)=>{
    event.preventDefault();
    if(busy||!subject.trim()||!description.trim())return;
    setBusy(true);setError('');
    try{
      const response=await fetch('/api/v1/staff/support/feedback',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({location:locationCode,category,
          subject:subject.trim(),description:description.trim(),
          idempotencyKey:requestKey}),
      });
      const body=await response.json() as {ok:boolean;data?:{taskId:string};
        error?:{code:string}};
      if(!response.ok||!body.ok||!body.data?.taskId)
        throw Error(body.error?.code??'Feedback could not be saved.');
      setSaved(body.data);
      window.dispatchEvent(new Event('ecfs:feedback-submitted'));
    }catch(e){
      setError(e instanceof Error?e.message:'Feedback could not be saved.');
    }finally{setBusy(false);}
  };
  return <div className="ecfs-help-feedback-backdrop" onMouseDown={event=>{
    if(event.target===event.currentTarget&&!busy)onClose();
  }}>
    <section role="dialog" aria-modal="true" aria-label="Help & Feedback"
      className="ecfs-help-feedback-dialog">
      <header><h2>Help &amp; Feedback</h2>
        <button type="button" aria-label="Close Help & Feedback"
          disabled={busy} onClick={onClose}>×</button>
      </header>
      {saved?<div role="status">
        <p>Submitted for follow-up in App Support / East Coast Float Spa Support.</p>
        <button type="button" onClick={onClose}>Close</button>
      </div>:<form onSubmit={event=>void submit(event)}>
        <label>What can we help with?
          <select aria-label="Help category" value={category} onChange={e=>{
            setCategory(e.target.value as Category);edit();
          }}>
            {Object.entries(categoryLabels).map(([id,title])=>
              <option key={id} value={id}>{title}</option>)}
          </select>
        </label>
        <label>Subject
          <input aria-label="Help subject" maxLength={160} required
            value={subject} onChange={e=>{setSubject(e.target.value);edit();}}/>
        </label>
        <label>Details
          <textarea aria-label="Help details" maxLength={6000} rows={6}
            required value={description}
            onChange={e=>{setDescription(e.target.value);edit();}}/>
        </label>
        <p>Submissions create a task for authorized App Support staff to follow up.</p>
        {error&&<p role="alert">{error}</p>}
        <footer><button type="button" disabled={busy}
            onClick={onClose}>Cancel</button>
          <button type="submit" disabled={busy||!subject.trim()||!description.trim()}>
            {busy?'Submitting…':'Submit'}</button>
        </footer>
      </form>}
    </section>
  </div>;
}
